var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvoicesDarkmode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 14C17.5817 14 14 17.5817 14 22V78C14 82.4183 17.5817 86 22 86H78C82.4183 86 86 82.4183 86 78V22C86 17.5817 82.4183 14 78 14H22ZM24 21C22.3431 21 21 22.3431 21 24V76C21 77.6569 22.3431 79 24 79H76C77.6569 79 79 77.6569 79 76V24C79 22.3431 77.6569 21 76 21H24Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 36,
    width: 22,
    height: 6,
    rx: 3,
    transform: "rotate(180 61 36)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 53,
    width: 33,
    height: 6,
    rx: 3,
    transform: "rotate(180 72 53)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 70,
    width: 28,
    height: 6,
    rx: 3,
    transform: "rotate(180 67 70)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 36,
    width: 6,
    height: 6,
    rx: 3,
    transform: "rotate(180 34 36)",
    fill: "#EB6087"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 53,
    width: 6,
    height: 6,
    rx: 3,
    transform: "rotate(180 34 53)",
    fill: "#EB6087"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 70,
    width: 6,
    height: 6,
    rx: 3,
    transform: "rotate(180 34 70)",
    fill: "#EB6087"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvoicesDarkmode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/invoices-darkmode.2f09fba40b794862d9ae44ef887b24c7.svg";